import { OutlinedCard } from "@bridgesplit/ui";
import { summarizeVaultSuppliedDeposits, useOraclePrices } from "@bridgesplit/abf-react";

import { useVaultContext } from "../VaultContext";
import VaultLoanAllocation from "./allocation/VaultLoanAllocation";
import VaultOverview from "./overview/VaultOverview";
import MarketParams from "./params/MarketParams";
import { SuppliedProgressBar } from "../SuppliedProgressBar";

export default function VaultInfo() {
    const { vaultExpanded } = useVaultContext();
    const { principalSupplied, principalLimit } = summarizeVaultSuppliedDeposits(vaultExpanded);
    const isGenesisVault = vaultExpanded?.vaultMetadata?.isGenesisVault;
    const { getUsdPrice } = useOraclePrices([vaultExpanded?.vault.principalMint]);
    const usdPrice = getUsdPrice(vaultExpanded?.vault.principalMint);

    return (
        <>
            {isGenesisVault && (
                <OutlinedCard padding={2} spacing={2}>
                    <SuppliedProgressBar
                        principalSupplied={principalSupplied}
                        principalLimit={principalLimit}
                        principalUsdPrice={usdPrice ?? 0}
                        theme={vaultExpanded?.vaultMetadata?.themeColor}
                        showBothCurrencyValues={true}
                        metadata={vaultExpanded?.principalMetadata}
                    />
                </OutlinedCard>
            )}
            <VaultOverview />
            <VaultLoanAllocation />
            <MarketParams />
        </>
    );
}
